
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { FlowBaseInfo } from '~src/flow/models/FlowInfo';
import { openCreateFlowRunTaskDialog, openCreateFlowRunTaskDialogWithMultipleFlows } from '~src/flow/utils/FlowDialogUtils';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { ScheduleLinkedTaskReduxAction } from '../actions/ScheduleLinkedTaskAction';
import { ScheduleSingleFlowTaskReduxAction } from '../actions/ScheduleSingleFlowTaskAction';


export function* handleScheduleSingleFlowTask(action: ScheduleSingleFlowTaskReduxAction) {
  try {
    yield call(openCreateFlowRunTaskDialog, action.flow as FlowBaseInfo);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}


export function* handleScheduleLinkedTask(action: ScheduleLinkedTaskReduxAction) {
  try {
    const targetFlows = action.targetFlows;
    const flowInfos = targetFlows.map((flow: IContentInfo) => flow as FlowBaseInfo);
    yield call(openCreateFlowRunTaskDialogWithMultipleFlows, flowInfos, undefined, true);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
